import { dictionary } from 'utility/dictionary'

interface ISSConsts {
  settings: ISSConstsSettings
  translation: {
    blue: string
    red: string
    green: string
    yellow: string
    purple: string
    orange: string
    port: string
    voyageNumber: string
    vessel: string
    line: string
    arrival: string
    departure: string
    harbour: string
    scError: string
    chooseVoyage: string
  }
}

interface ISSConstsSettings {
  limit: number
  dateFormat: string
}

export const SSConsts: ISSConsts = {
  settings: {
    limit: 6,
    dateFormat: 'ddd,  dd. MMM - HH:mm',
  },

  translation: {
    blue: dictionary('scBlueLine'),
    red: dictionary('scRedLine'),
    green: dictionary('scGreenLine'),
    yellow: dictionary('scYellowLine'),
    purple: dictionary('scPurpleLine'),
    orange: dictionary('scOrangeLine'),
    port: dictionary('scPort'),
    voyageNumber: dictionary('scVoyageNumber'),
    vessel: dictionary('scVessel'),
    line: dictionary('scLine'),
    arrival: dictionary('scArrival'),
    departure: dictionary('scDeparture'),
    harbour: dictionary('scHarbour'),
    scError: dictionary('scError'),
    chooseVoyage: dictionary('blsscChooseVoyage'),
  },
}
